import React from "react";
import { Coming } from "../../../components/Coming/Coming.jsx";
import "./Deliquency.css";
const Deliquency = () => {
  return (
    <div>
      <Coming />
    </div>
  );
};

export default Deliquency;
